/* eslint-disable */
export default {
  download: 'Télécharger',
} as const;

// @key: @#@"download"@#@ @source: @#@"Download"@#@
